"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var OTHERS_SLUG = 'other';
function alphaSortCategories(categories) {
    return categories.sort(function (a, b) {
        if (a.slug === OTHERS_SLUG) {
            return 1;
        }
        if (b.slug === OTHERS_SLUG) {
            return -1;
        }
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });
}
var Category = /** @class */ (function () {
    function Category(attributes, parent) {
        if (attributes === void 0) { attributes = {}; }
        if (parent === void 0) { parent = null; }
        this.attributes = attributes;
        this.parent = parent;
    }
    Object.defineProperty(Category.prototype, "id", {
        get: function () {
            return String(this.attributes.id);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "name", {
        get: function () {
            return this.attributes.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "slug", {
        get: function () {
            return this.attributes.slug;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "uuid", {
        get: function () {
            return this.attributes.uuid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "isSelectableCategory", {
        get: function () {
            return this.isRoot || !this.hasChildren;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "displayName", {
        get: function () {
            var names = [this.name];
            this.ancestors.forEach(function (cat) {
                names.push(cat.name);
            });
            return names.reverse().join(' > ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "root", {
        get: function () {
            if (this.isRoot) {
                return this;
            }
            return this.ancestors.reverse()[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "isRoot", {
        get: function () {
            return this.ancestors.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "hasChildren", {
        get: function () {
            return this.children.length !== 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "inSameBranch", {
        get: function () {
            return this.root.flattenedChildren();
        },
        enumerable: true,
        configurable: true
    });
    Category.prototype.isInSameBranch = function (category) {
        return this.root.id === category.root.id;
    };
    Category.prototype.flattenedChildren = function (flattened, currentCategories) {
        var _this = this;
        if (flattened === void 0) { flattened = []; }
        if (currentCategories === void 0) { currentCategories = this.children; }
        currentCategories.forEach(function (cat) {
            flattened.push(cat);
            _this.flattenedChildren(flattened, cat.children);
        });
        return flattened;
    };
    Object.defineProperty(Category.prototype, "ancestors", {
        get: function () {
            var ancestors = [];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var currentNode = this;
            while (currentNode.parent) {
                ancestors.push(currentNode.parent);
                currentNode = currentNode.parent;
            }
            return ancestors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "children", {
        get: function () {
            var _this = this;
            return alphaSortCategories(this.attributes.children.map(function (cat) { return new Category(cat, _this); }));
        },
        enumerable: true,
        configurable: true
    });
    return Category;
}());
var CategoryTree = /** @class */ (function () {
    function CategoryTree(attributesArray) {
        this.categories = alphaSortCategories(attributesArray.map(function (atts) { return new Category(atts); }));
    }
    CategoryTree.prototype.flattened = function (arr, currentCategories) {
        var _this = this;
        if (arr === void 0) { arr = []; }
        if (currentCategories === void 0) { currentCategories = this.categories; }
        currentCategories.forEach(function (cat) {
            if (cat.isSelectableCategory) {
                arr.push(cat);
            }
            _this.flattened(arr, cat.children);
        });
        return arr;
    };
    CategoryTree.prototype.findById = function (id) {
        if (id) {
            return this.flattened().find(function (cat) { return String(cat.id) === String(id); });
        }
        return null;
    };
    CategoryTree.prototype.findByIds = function (ids) {
        if (ids) {
            var stringIds_1 = ids.map(function (id) { return String(id); });
            return this.flattened().filter(function (cat) { return lodash_1.includes(stringIds_1, cat.id); });
        }
        return [];
    };
    return CategoryTree;
}());
exports.default = CategoryTree;
//# sourceMappingURL=category_tree.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/category_select/category_tree.js
// module id = Nisb
// module chunks = 20 21